const isDevelopment = process.env.NODE_ENV === 'development';

const logError = (message: string, error?: any) => {
  if (isDevelopment) {
    console.warn(message, error);
  }
};

export const localStorageUtils = {

  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      logError(`Failed to get item "${key}" from localStorage:`, error);
      return null;
    }
  },

  setItem: (key: string, value: string): boolean => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      logError(`Failed to set item "${key}" in localStorage:`, error);
      return false;
    }
  },

  removeItem: (key: string): boolean => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      logError(`Failed to remove item "${key}" from localStorage:`, error);
      return false;
    }
  },

  isAvailable: (): boolean => {
    try {
      const testKey = '__localStorage_test__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }
};

export const STORAGE_KEYS = {
  PIN_CODE: 'pinCode',
  FONT_THEME: 'fontTheme',
  ACCENT_THEME: 'accentTheme',
} as const;
